import { createI18n } from 'vue-i18n';
import { en } from '@/lang/en';
import { it } from '@/lang/it';
import store from '@/store';

const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

let lang;
let htmlLang;
if (params?.language && params?.language.toUpperCase() === 'EN') {
  store.dispatch('setLanguage', 'EN');
  lang = en;
  htmlLang = 'en';
} else {
  store.dispatch('setLanguage', 'IT');
  lang = it;
  htmlLang = 'it';
}

// Update the lang attribute on <html> for accessibility (screen readers)
document.documentElement.lang = htmlLang;

export const i18n = createI18n({
  locale: 'lang',
  fallbackLocale: 'lang',
  messages: { lang },
  lazy: true
});
